import { useEffect } from 'react';

const upsertMeta = (attribute, key, content) => {
    if (!content) return;
    let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
    }
    element.setAttribute('content', content);
};

const ensureTrailingSlash = (value) => {
    if (!value || /[?#]/.test(value)) return value;
    return value.endsWith('/') ? value : `${value}/`;
};

const BlogSeo = ({ title, description, canonicalPath, image, noIndex = false, type = 'article' }) => {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = title || 'AmitaSoft Blogs';

        upsertMeta('name', 'description', description);
        upsertMeta('property', 'og:title', title);
        upsertMeta('property', 'og:description', description);
        upsertMeta('property', 'og:type', type);
        upsertMeta('name', 'robots', noIndex ? 'noindex, nofollow' : 'index, follow');
        upsertMeta('name', 'twitter:card', 'summary_large_image');
        upsertMeta('name', 'twitter:title', title);
        upsertMeta('name', 'twitter:description', description);

        if (canonicalPath) {
            const canonicalUrl = `${window.location.origin}${ensureTrailingSlash(canonicalPath)}`;
            upsertMeta('property', 'og:url', canonicalUrl);

            let link = document.head.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement('link');
                link.setAttribute('rel', 'canonical');
                document.head.appendChild(link);
            }
            link.setAttribute('href', canonicalUrl);
        }

        if (image) {
            const imageUrl = image.startsWith('http') ? image : `${window.location.origin}${process.env.PUBLIC_URL || ''}${image}`;
            upsertMeta('property', 'og:image', imageUrl);
            upsertMeta('name', 'twitter:image', imageUrl);
        }

        return () => {
            document.title = previousTitle;
        };
    }, [title, description, canonicalPath, image, noIndex, type]);

    return null;
};

export default BlogSeo;
